
import { Chart } from "react-google-charts";
import { useResizeDetector } from "react-resize-detector";

const TicketRaiseChart = () => {
  const { width, ref } = useResizeDetector();

  const data = [
    ["Month", "Tickets"],
    ["Jan", 520],
    ["Feb", 610],
    ["Mar", 480],
    ["Apr", 560],
    ["May", 650],
    ["Jun", 740],
    ["Jul", 820],
    ["Aug", 900],
    ["Sep", 520],
    ["Oct", 620],
    ["Nov", 650],
    ["Dec", 600],
  ];

  const options = {
    legend: "none",
    backgroundColor: "transparent",
    bar: { groupWidth: "43%" },

    chartArea: {
      width: "100%",
      height: "75%",
      top: 20,
      left: 45,
    },

    hAxis: {
      textStyle: {
        color: "#9CA3AF",
        fontSize: 11,
      },
      gridlines: { color: "transparent" },
      baselineColor: "transparent",
    },

    vAxis: {
      minValue: 0,
      maxValue: 1000,
      ticks: [0, 250, 500, 750, 1000],
      textStyle: {
        color: "#9CA3AF",
        fontSize: 11,
      },
      gridlines: { color: "transparent" },
      baselineColor: "transparent",
    },

    tooltip: {
      trigger: "focus",
      textStyle: { fontSize: 12 },
    },
  };

  return (
    <div
      ref={ref}
      className="
        h-[330px] p-4 rounded-xl
        bg-white dark:bg-slate-800
        border border-slate-200 dark:border-slate-700
        shadow-sm
      "
    >
      {/* HEADER */}
      <div className="flex items-center justify-between mb-3">
        <h6 className="text-sm font-semibold text-slate-900 dark:text-slate-100">
          Ticket Raised
        </h6>

        <select
          className="
            text-xs px-2 py-1 rounded-md
            bg-white dark:bg-slate-900
            border border-slate-300 dark:border-slate-600
            text-slate-700 dark:text-slate-300
            focus:outline-none
          "
        >
          <option>All</option>
          <option>Course 1</option>
          <option>Course 2</option>
        </select>
      </div>

      {/* CHART */}
      <div className="relative">
        {width && (
          <Chart
            chartType="ColumnChart"
            data={data}
            width={width}
            height="260px"
            options={options}
          />
        )}

        {/* BAR RADIUS + GRADIENT */}
        <style>
          {`
            svg rect {
              rx: 12;
              ry: 12;
              fill: url(#ticketBarGradient);
            }
          `}
        </style>

        <svg width="0" height="0">
          <defs>
            <linearGradient
              id="ticketBarGradient"
              x1="0"
              y1="0"
              x2="0"
              y2="1"
            >
             <stop offset="0%" stopColor="#5A57FF" />
<stop offset="70%" stopColor="#6c75ec" stopOpacity="0.35" />
<stop offset="100%" stopColor="#e3ebf1" stopOpacity="0.1" />
            </linearGradient>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default TicketRaiseChart;